import { Grid2, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

import addAnnotationIcon from 'assets/images/help/annotations/add-annotation.png'
import TagPeopleInAnnotations from 'assets/images/help/annotations/tag-people.png'
import ViewAnnotations from 'assets/images/help/annotations/view-annotations.png'
import AttachPictures from 'assets/images/help/annotations/attach-pictures.png'

const annotationsSections = [
  {
    id: "Add an Annotation",
    title: "Add an Annotation",
    description: "Drop a pin anywhere in your 3D model to leave a note, highlight an issue, or mark progress or assign tasks and collaborate effortlessly.",
    icon: 'fluent:chat-add-32-regular',
    image: addAnnotationIcon,
  },
  {
    id: "Tag People in Annotations",
    title: "Tag People in Annotations",
    description: "Use @mentions to tag team members and assign responsibilities directly within the annotation.",
    icon: 'material-symbols:alternate-email',
    image: TagPeopleInAnnotations,
  },
  {
    id: "View Annotations",
    title: "View Annotations",
    description: "Click on any annotation to instantly jump to its location and see the attached notes, comments, and context.",
    icon: 'iconamoon:comment-dots-light',
    image: ViewAnnotations,
  },
  {
    id: "Attach Pictures",
    title: "Attach Pictures",
    description: "Add files like drawings, or photos to any annotation. Keep all related info in one place for faster reviews and decisions.",
    icon: 'icon-park-outline:upload-picture',
    image: AttachPictures,
  },
]

const AnnotationsPage = () => {
  return (
    <Grid2 container justifyContent="center" alignItems="center" columnGap={6} rowGap={4}>
      {/* <Grid2 container spacing={1.5}> */}
        {annotationsSections.map((section) => (
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems="center" key={section.id}>
                <img 
                  src={section.image} 
                  alt={section.title} 
                  style={{ 
                    // width: '100%', 
                    // height: '100%',
                    maxHeight: '10rem',
                    objectFit: 'cover',
                    aspectRatio: '16/9',
                                          borderRadius: '8px'
                  }} 
                />
              <Stack spacing={1} sx={{
                
              }}>
                  <Icon 
                    icon={section.icon} 
                    style={{ 
                      width: '1.5rem', 
                      height: '1.5rem',
                      marginBottom: ".5rem",
                    }} 
                  />
                <Typography variant="subtitle1" sx={{ fontWeight: 'medium', fontSize: '.875rem' }}>
                  {section.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '.75rem', maxWidth: '18rem', textWrap: 'balance' }}>
                  {section.description}
                </Typography>
              </Stack>
          </Stack>
        ))}
      {/* </Grid2> */}
    </Grid2>
  )
}

export default AnnotationsPage